import { createContext, useState, useMemo, useCallback } from 'react'
import { node } from 'prop-types'
import { api } from 'api'

export const integrationContext = createContext({})

export const IntegrationProvider = ({ children }) => {
  const [inboundById, setInboundById] = useState({})
  const [outboundById, setOutboundById] = useState({})

  const fetchIntegrations = useCallback(
    () =>
      api.get('/api/v1/integrations/active').then(({ data }) => {
        const sorted = data.reduce(
          (acc, integration) => {
            let copy
            if (integration.type === 'OUTPUT' || integration.type === 'SUPPLEMENTAL') {
              copy = { ...acc, out: { ...acc.out, [integration.id]: { ...integration } } }
            }
            if (integration.type === 'INPUT') {
              copy = { ...acc, in: { ...acc.in, [integration.id]: { ...integration } } }
            }
            return copy
          },
          { out: {}, in: {} },
        )

        setOutboundById(sorted.out)
        setInboundById(sorted.in)
        return data
      }),
    [],
  )

  const value = useMemo(
    () => ({
      inboundById,
      outboundById,
      fetchIntegrations,
    }),
    [inboundById, outboundById, fetchIntegrations],
  )

  return <integrationContext.Provider value={value}>{children}</integrationContext.Provider>
}

IntegrationProvider.propTypes = {
  children: node.isRequired,
}
